







import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';

@Component({
  components: {
    NewTranslation,
    Button,
  },
})
export default class AddBIObjectButton extends Vue {
  @Emit()
  public click(): void {}
}
